import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select, { components } from "react-select";

import ChartPlot from "../../../components/plot";

import {
  TagColorOptions,
  XlsNormalizefileKey,
} from "../../../utils/constantsString";

import { getHeaders } from "../../../network/cipAPI";

const ReplacementResultChart = React.forwardRef((props, ref) => {
  const normalizedCategories = [
    XlsNormalizefileKey.feedPressure,
    XlsNormalizefileKey.normalizeDPRack2,
    XlsNormalizefileKey.normalizePermeateFlow,
    XlsNormalizefileKey.normalizeSaltPassage,
    XlsNormalizefileKey.permeateConductivity,
    XlsNormalizefileKey.pressureDrop,
  ];
  const otherCategories = [
    XlsNormalizefileKey.permeateFlow,
    XlsNormalizefileKey.failureProbability,
  ];

  const getColor = (key, index) => {
    if (key.label === XlsNormalizefileKey.normalizePermeateFlow) {
      return "#00A9E0";
    } else if (key.label === XlsNormalizefileKey.permeateFlow) {
      return "#0000FF";
    } else if (key.label === XlsNormalizefileKey.normalizeDPRack2) {
      return "#58B947";
    } else if (key.label === XlsNormalizefileKey.feedPressure) {
      return "#228B22";
    } else if (key.label === XlsNormalizefileKey.pressureDrop) {
      return "#00A36C";
    } else if (key.label === XlsNormalizefileKey.permeateConductivity) {
      return "#8B0000";
    } else if (key.label === XlsNormalizefileKey.normalizeSaltPassage) {
      return "#e4001c";
    } else if (key.label === XlsNormalizefileKey.failureProbability) {
      return "#FF9E19";
    }
    return TagColorOptions[index % 10].code;
  };

  const { t, i18n } = useTranslation();
  const { plotData } = props;
  const [options, setOptions] = useState(null);
  const [selectedValues, setSelectedValues] = useState(null);
  const [selectedValuesUpdated, setSelectedValuesUpdated] = useState(null);
  const [headerOptions, setHeaderOptions] = useState(null);

  const NoOptionsMessage = (props) => {
    return (
      <components.NoOptionsMessage {...props}>
        <span className="custom-css-class">{t("ValueStrings.noOption")}</span>
      </components.NoOptionsMessage>
    );
  };

  useEffect(() => {
    const fetchHeader = async () => {
      if (plotData) {
        // const replacements = [
        //   "Age",
        //   "Warranty",
        //   // "Cleaning",
        //   // "Failure Probability",
        // ];
        let headerResponse = await getHeaders();
        headerResponse = headerResponse?.data;
        if (headerResponse) {
          let normalizedOptions = [];
          let others = [];

          Object.keys(headerResponse).forEach((key, index) => {
            const value = headerResponse[key];
            if (normalizedCategories.includes(key)) {
              const historicalDataX = plotData[key]["historical_x"];
              const forecateDataX = plotData[key]["forecasted_x"];
              const xaxis = historicalDataX.concat(forecateDataX);
              const historicalDataY = plotData[key]["historical_y"];
              const forecateDataY = plotData[key]["forecasted_y"];
              const yaxis = historicalDataY.concat(forecateDataY);
              const upperLimitData = plotData[key]["upper_limit"];
              const lowerLimitData = plotData[key]["lower_limit"];

              let cips = plotData[key]["cips"];
              let replacement_cips = [];
              cips.forEach((cip) => {
                if (cip) {
                  replacement_cips.push({
                    start_date: cip,
                    is_tool_identified: true,
                  });
                }
              });

              normalizedOptions.push({
                label: key,
                value: value,
                xAxisData: xaxis,
                yAxisData: yaxis,
                cip: replacement_cips,
                forecateDataX: forecateDataX,
                threshold: plotData[key]["threshold"],
                upperLimit: upperLimitData,
                lowerLimit: lowerLimitData,
                replacement_date: plotData[key]["replacement_date"],
              });
            } else if (otherCategories.includes(key)) {
              const historicalDataX = plotData[key]["historical_x"];
              const forecateDataX = plotData[key]["forecasted_x"];
              const xaxis = historicalDataX.concat(forecateDataX);
              const historicalDataY = plotData[key]["historical_y"];
              const forecateDataY = plotData[key]["forecasted_y"];
              const yaxis = historicalDataY.concat(forecateDataY);
              const upperLimitData = plotData[key]["upper_limit"];
              const lowerLimitData = plotData[key]["lower_limit"];

              let cips = plotData[key]["cips"];
              let replacement_cips = [];
              cips.forEach((cip) => {
                if (cip) {
                  replacement_cips.push({
                    start_date: cip,
                    is_tool_identified: true,
                  });
                }
              });

              others.push({
                label: key,
                value: value,
                xAxisData: xaxis,
                yAxisData: yaxis,
                forecateDataX: forecateDataX,
                cip: replacement_cips,
                threshold: plotData[key]["threshold"],
                upperLimit: upperLimitData,
                lowerLimit: lowerLimitData,
                replacement_date: plotData[key]["replacement_date"],
              });
            }
          });

          const options = [];
          options.push({
            label: t("ValueStrings.default"),
            options: normalizedOptions,
          });
          options.push({ label: t("ValueStrings.optional"), options: others });
          setOptions(options);
          setSelectedValues(normalizedOptions);
        }
        setHeaderOptions(headerResponse);
      }
    };
    fetchHeader();
  }, [plotData]);

  useEffect(() => {
    if (selectedValues && selectedValues.length > 0 && headerOptions !== null) {
      selectedValues.map((header) => {
        return (header.value = headerOptions[header.label]);
      });
      setSelectedValuesUpdated(true);
    }
  }, [headerOptions]);

  const onCheckChange = (value, key) => {
    setSelectedValues(value);
  };

  return (
    <div>
      {selectedValuesUpdated && (
        <>
          <Select
            options={options}
            name="label"
            value={selectedValues}
            isMulti
            onChange={onCheckChange}
            placeholder={t("ValueStrings.select")}
            components={{ NoOptionsMessage }}
            getOptionLabel={(option) => option.value}
          />
          {plotData && selectedValues && selectedValues?.length > 0 && (
            <>
              <div className="flex-center-center margin-top-10 ">
                <span className="font10 errorText12 margin-left-10 ">
                  {`| ${t("IdentifiedCIPStrings.replacementDateRedLine")}`}
                  {"   "}
                </span>
                <span className="errorText12 margin-left-10 font10">
                  {`---  ${t("IdentifiedCIPStrings.dottedLine")}`}{" "}
                </span>

                <span className="upper  margin-left-10">
                  {`... ${t("IdentifiedCIPStrings.upperLimit")}`}
                </span>
                <span className="descriptionText  margin-left-10 font10">
                  {`| ${t("IdentifiedCIPStrings.blackLines")}`}{" "}
                </span>
                <span className="lower  margin-left-10">
                  {`... ${t("IdentifiedCIPStrings.lowerLimit")}`}
                </span>
              </div>
              <div className="margin-top-10">
                {selectedValues.map((key, index) => (
                  <ChartPlot
                    key={`replacement-chart-${key["label"]}-${index}`}
                    title={key["value"]}
                    label={key["label"]}
                    color={getColor(key, index)}
                    i18n={i18n}
                    date={key["xAxisData"]}
                    data={key["yAxisData"]}
                    cips={key["cip"]}
                    forecateDataX={key["forecateDataX"]}
                    threshold={[key["threshold"]]}
                    upperLimitData={[key["upperLimit"]]}
                    lowerLimitData={[key["lowerLimit"]]}
                    showCIPs
                    replacement_date={[key["replacement_date"]]}
                  />
                ))}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
});
export default ReplacementResultChart;
